/* product-form.js — kopia motywu z DWIEMA zmianami. Reszta bez zmian.

   1. GUARD NA `cartNotification`. Oryginał wołał `this.cartNotification`
      w trzech miejscach BEZ sprawdzenia, czy element istnieje (linie 20, 36, 51
      w wersji sprzed zmiany). `<cart-notification>` renderuje się z `header.liquid`
      i dziś jest — ale gdyby kiedykolwiek zniknął, wyjątek poleciałby PRZED
      `fetch`, więc pozycja nie doszłaby do koszyka, a klient zobaczyłby przycisk
      w stanie ładowania i nic więcej. Awaria cichsza niż błąd 500 i gorsza,
      bo wygląda jak „nie kliknąłem".

      To nie jest hipotetyczne: przy dokładaniu szuflady koszyka naturalnym
      odruchem jest „usuwamy notification, mamy drawer". Guard sprawia, że taki
      ruch najwyżej wyłącza popup, zamiast wyłączać sprzedaż.

   2. ZDARZENIE `pers:koszyk-dodano` po udanym dodaniu. Szuflada NIE jest tu
      nigdzie wymieniona z nazwy — ten plik ogłasza fakt, a kto chce, ten słucha.
      Dzięki temu product-form nie wie o szufladzie, a szuflada nie musi
      podmieniać niczego w tym pliku.

   Reszta pliku jest przepisana z motywu bez ingerencji. */

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector('cart-notification');
      }

      /* Sekcje do odswiezenia. Notification podaje swoje, a my dokladamy
         szuflade, jesli jest na stronie. Gdy notification zniknie, zostaje
         sama szuflada — i odwrotnie. Zadne z dwojga nie jest wymagane. */
      sekcjeDoOdswiezenia() {
        var lista = [];
        if (this.cartNotification && this.cartNotification.getSectionsToRender) {
          lista = this.cartNotification.getSectionsToRender().map(function (s) { return s.id; });
        }
        var szuflada = document.getElementById('pers-koszyk');
        if (szuflada && szuflada.dataset.sekcja) lista.push(szuflada.dataset.sekcja);
        return lista;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains('loading')) return;

        this.handleErrorMessage();
        if (this.cartNotification) {
          this.cartNotification.setActiveElement(document.activeElement);
        }

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove(
          'hidden'
        );

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        formData.append('sections', this.sekcjeDoOdswiezenia());
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            if (this.cartNotification) {
              this.cartNotification.renderContents(response);
            }

            // Fakt, nie polecenie. Kto slucha, ten reaguje.
            document.dispatchEvent(new CustomEvent('pers:koszyk-dodano', {
              detail: { odpowiedz: response },
            }));
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add(
              'hidden'
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
